import { States } from 'safe'
import {
  DealerTypes,
  GET_DELIVERY_NOTES_BY_CLIENT,
  SellerTypes,
  SET_DEALERS,
} from '../actions/actionTypes'

const initialState: States.DeliveryNotesByClient = {
  deliveryNotesByClient: [],
  numberOfPages: 0,
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: SellerTypes
): States.DeliveryNotesByClient => {
  switch (action.type) {
    case GET_DELIVERY_NOTES_BY_CLIENT:
      return { ...action.payload }
    default:
      return state
  }
}
